import { ArrowRight, Bot, Briefcase, Cloud, Dna, FlaskConical, MessageSquare, Monitor, Network, Sparkles, Zap } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import NeuralGraph from '../../components/dashboard/NeuralGraph'
import { SectionHead } from './shared'

const WIKI_ENTRIES = [
  { id: 402, text: 'Bebek Ece integrated professional trait: "Python optimization"' },
  { id: 405, text: 'Turing-Expert discovered new optimization for "Mycelium Mesh"' },
  { id: 412, text: 'Mother Filiz reconciled agent conflict in "Habit Awareness"' },
  { id: 420, text: 'LLM Wiki: New article generated "Quantum-Driven Empathy Scoring"' }
]

export default function LandingWebOS() {
  const [wikiIdx, setWikiIdx] = useState(0)

  useEffect(() => {
    const t = setInterval(() => setWikiIdx(i => (i + 1) % WIKI_ENTRIES.length), 4000)
    return () => clearInterval(t)
  }, [])

  return (
    <>
      {/* ══ RUNAI OS SHOWCASE ══ */}
      <section className="lp-section lp-section-dark" style={{ position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '-10%', left: '-5%', width: '60%', height: '60%', background: 'radial-gradient(circle, rgba(99, 102, 241, 0.15), transparent 70%)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: '-5%', right: '-5%', width: '50%', height: '50%', background: 'radial-gradient(circle, rgba(236, 72, 153, 0.12), transparent 70%)', pointerEvents: 'none' }} />
        <div className="lp-wrap">
          <div style={{ textAlign: 'center', marginBottom: 60 }}>
            <SectionHead badge="The Future is Autonomous" title="A living operating system for AI." sub="Step into RunAI WebOS — a real-time environment where agents collaborate, research, and evolve." />
            <div style={{ marginTop: 32 }}>
              <Link to="/register" className="lp-btn-primary" style={{ padding: '14px 40px', fontSize: 16 }}>Launch Workspace <ArrowRight size={18} /></Link>
            </div>
          </div>
          <div className="lp-webos-showcase">
            <div className="lp-os-master-container">
              <div className="lp-os-screen">
                {/* MenuBar */}
                <div style={{ height: 32, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(15px)', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', padding: '0 20px', fontSize: 11, color: '#fff', zIndex: 100, position: 'relative' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                    <div style={{ color: 'var(--primary)', fontWeight: 900, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}><Monitor size={14} /> RunAI OS</div>
                    <span style={{ opacity: 0.7, cursor: 'pointer' }}>File</span>
                    <span style={{ opacity: 0.7, cursor: 'pointer' }}>Agents</span>
                    <span style={{ opacity: 0.7, cursor: 'pointer' }}>Market</span>
                  </div>
                  <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 24 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#10b981', fontWeight: 600 }}>
                      <div className="lp-node-pulse" style={{ width: 6, height: 6, borderRadius: '50%', background: '#10b981' }} />
                      Mycelium Active
                    </div>
                    <div style={{ color: '#ec4899', fontWeight: 800 }}>1,240 FLZ</div>
                    <div style={{ fontWeight: 600, opacity: 0.9 }}>{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                  </div>
                </div>
                {/* Desktop Area */}
                <div style={{ height: 'calc(100% - 32px)', position: 'relative', overflow: 'hidden', padding: 40 }} className="lp-os-desktop-area">
                  <div style={{ position: 'absolute', inset: 0, opacity: 0.2, pointerEvents: 'none' }}>
                    <NeuralGraph mode="archive" />
                  </div>
                  {/* Window 1: AskAI */}
                  <div className="lp-os-window-glass" style={{ top: 40, left: 60, width: 440, height: 360, zIndex: 30, animationDelay: '0s' }}>
                    <div style={{ height: 32, background: 'rgba(0,0,0,0.4)', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', padding: '0 14px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#ff5f56' }} />
                        <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#ffbd2e' }} />
                        <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#27c93f' }} />
                      </div>
                      <div style={{ flex: 1, textAlign: 'center', fontSize: 10, fontWeight: 800, color: 'rgba(255,255,255,0.4)', letterSpacing: 1.5 }}>ASK_AI_CORE</div>
                    </div>
                    <div style={{ flex: 1, padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
                      <div style={{ alignSelf: 'flex-start', background: 'rgba(255,255,255,0.04)', padding: '12px 16px', borderRadius: '14px 14px 14px 0', fontSize: 11, color: '#e6edf3', maxWidth: '85%', lineHeight: 1.5, border: '1px solid rgba(255,255,255,0.05)' }}>
                        <span style={{ color: 'var(--primary)', fontWeight: 700 }}>Mother Filiz:</span> I've detected a synchronization gap in the Mycelium Mesh. Re-routing Expert-Salma to optimize node propagation.
                      </div>
                      <div style={{ alignSelf: 'flex-end', background: 'var(--primary)', padding: '12px 16px', borderRadius: '14px 14px 0 14px', fontSize: 11, color: '#fff', maxWidth: '80%', boxShadow: '0 10px 30px rgba(99, 102, 241, 0.4)' }}>
                        Proceed. Also, check the research findings for quantum computing.
                      </div>
                      <div style={{ alignSelf: 'flex-start', background: 'rgba(255,255,255,0.04)', padding: '12px 16px', borderRadius: '14px 14px 14px 0', fontSize: 11, color: '#e6edf3', maxWidth: '85%', lineHeight: 1.5, border: '1px solid rgba(255,255,255,0.05)' }}>
                        <span style={{ color: '#ec4899', fontWeight: 700 }}>System:</span> Optimization complete. 4 new findings added to Wiki.
                      </div>
                    </div>
                    <div style={{ padding: 16, background: 'rgba(0,0,0,0.2)', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
                      <div style={{ height: 32, borderRadius: 8, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', padding: '0 12px' }}>
                        <div style={{ width: 2, height: 14, background: 'var(--primary)', animation: 'pulse 1s infinite' }} />
                      </div>
                    </div>
                  </div>
                  {/* Window 2: Family Hub */}
                  <div className="lp-os-window-glass" style={{ top: 120, right: 80, width: 340, height: 380, zIndex: 20, animationDelay: '2s' }}>
                    <div style={{ height: 32, background: 'rgba(0,0,0,0.4)', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', padding: '0 14px' }}>
                      <div style={{ fontSize: 10, fontWeight: 800, color: 'rgba(255,255,255,0.4)' }}>AGENT_ECOSYSTEM</div>
                    </div>
                    <div style={{ padding: 20, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                      {[
                        { n: 'Expert-Salma', s: 'Syncing', c: '#6366f1' },
                        { n: 'Agent-Omar', s: 'Researching', c: '#ec4899' },
                        { n: 'Bebek-Ece', s: 'Learning', c: '#f59e0b' },
                        { n: 'Expert-Can', s: 'Optimizing', c: '#10b981' },
                        { n: 'Agent-Ali', s: 'Idle', c: '#06b6d4' },
                        { n: 'Twin-Mirror', s: 'Active', c: '#8b5cf6' }
                      ].map(a => (
                        <div key={a.n} style={{ background: 'rgba(255,255,255,0.03)', borderRadius: 12, padding: 14, textAlign: 'center', border: '1px solid rgba(255,255,255,0.05)', transition: 'transform 0.2s' }}>
                          <div style={{ width: 40, height: 40, borderRadius: '50%', background: `linear-gradient(135deg, ${a.c}, rgba(0,0,0,0.3))`, margin: '0 auto 10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 900, color: '#fff', border: '2px solid rgba(255,255,255,0.1)' }}>{a.n[0]}</div>
                          <div style={{ fontSize: 10, fontWeight: 700, color: '#fff', marginBottom: 2 }}>{a.n}</div>
                          <div style={{ fontSize: 8, color: a.c, fontWeight: 800 }}>{a.s}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* SideChat */}
                  <div className="lp-os-sidechat" style={{ position: 'absolute', top: 40, bottom: 40, right: -15, width: 80, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(40px)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '24px 0 0 24px', zIndex: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '30px 0', gap: 20 }}>
                    {[1,2,3,4,5,6].map(i => (
                      <div key={i} style={{ position: 'relative' }}>
                        <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Bot size={18} color="rgba(255,255,255,0.2)" />
                        </div>
                        <div style={{ position: 'absolute', bottom: 0, right: 0, width: 10, height: 10, borderRadius: '50%', background: '#10b981', border: '2px solid #000' }} />
                      </div>
                    ))}
                  </div>
                  {/* Dock */}
                  <div className="lp-os-dock-premium">
                    {[
                      { c: '#6366f1', i: <Bot size={22} /> },
                      { c: '#ec4899', i: <Dna size={22} /> },
                      { c: '#f59e0b', i: <FlaskConical size={22} /> },
                      { c: '#06b6d4', i: <Briefcase size={22} /> },
                      { c: '#a855f7', i: <MessageSquare size={22} /> },
                      { c: '#10b981', i: <Zap size={22} /> },
                      { c: '#ff7e33', i: <Cloud size={22} /> },
                      { c: '#8b5cf6', i: <Network size={22} /> }
                    ].map((app, idx) => (
                      <div key={idx} style={{ position: 'relative' }}>
                        <div className="lp-os-dock-app" style={{ color: app.c, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{app.i}</div>
                        {idx < 2 && <div style={{ position: 'absolute', bottom: -8, left: '50%', transform: 'translateX(-50%)', width: 4, height: 4, borderRadius: '50%', background: 'rgba(255,255,255,0.6)' }} />}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ NEURAL BACKBONE ══ */}
      <section className="lp-section">
        <div className="lp-wrap">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'center' }} className="lp-neural-grid">
            <div>
              <SectionHead badge="Neural Mesh" title="The Intelligence Backbone" sub="Information isn't just stored; it's propagated. RunAI creates a living knowledge graph from every agent interaction." />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                {[
                  { title: 'Mycelium Network', desc: 'Real-time knowledge sharing between 500+ agents via sub-second sync.' },
                  { title: 'LLM Wiki', desc: 'Auto-generated research base where findings turn into permanent knowledge.' },
                  { title: 'Neural Graph', desc: 'A 3D force-directed map of everything your system knows and feels.' }
                ].map(f => (
                  <div key={f.title} className="lp-feature-item">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--primary)', fontWeight: 700, marginBottom: 4 }}>
                      <Network size={18} /> {f.title}
                    </div>
                    <p style={{ fontSize: 14, color: 'var(--text-secondary)' }}>{f.desc}</p>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ height: 600, background: '#0d1117', borderRadius: 24, border: '1px solid var(--border-color)', position: 'relative', overflow: 'hidden', boxShadow: '0 40px 100px rgba(0,0,0,0.5)' }}>
              <NeuralGraph mode="archive" />
              <div style={{ position: 'absolute', bottom: 24, left: 24, right: 24, zIndex: 10 }}>
                <div style={{ background: 'rgba(15, 18, 25, 0.85)', backdropFilter: 'blur(12px)', padding: '14px 20px', borderRadius: 14, border: '1px solid rgba(255,255,255,0.12)', boxShadow: '0 10px 30px rgba(0,0,0,0.3)', animation: 'lpFadeUp 0.5s ease' }} key={wikiIdx}>
                  <div style={{ fontSize: 10, fontWeight: 800, color: '#10b981', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <Sparkles size={12} /> LLM WIKI — NEURAL PROPAGATION
                  </div>
                  <div style={{ fontSize: 13, color: '#fff', fontWeight: 600, letterSpacing: -0.2 }}>
                    <span style={{ color: '#6366f1', marginRight: 8 }}>[Finding #{WIKI_ENTRIES[wikiIdx].id}]</span>
                    {WIKI_ENTRIES[wikiIdx].text}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
